import React, {useContext} from "react";
import cartitem from "../css/cartitem.css";
import {ShopContext} from "./Providers/ShopContext";
import remove_icon from "./Assets/cart_cross_icon.png";

const CartItem = () => {
  const {all_product, cartItem, removeFromCart, getTotalCartAmount} =
    useContext(ShopContext);
  return (
    <div className="cartitem">
      <div className="format-main">
        <p>Products</p>
        <p>Title</p>
        <p>Price</p>
        <p>Quantity</p>
        <p>Total</p>
        <p>Remove</p>
      </div>
      <hr />
      <div>
        {all_product.map((e) => {
          if (cartItem[e.id] > 0) {
            return (
              <div>
                <div className="format format-main">
                  <img src={e.image} alt="" className="product-icon" />
                  <p>{e.name}</p>
                  <p>${e.new_price}</p>
                  <button className="quantity">{cartItem[e.id]}</button>
                  <p>${e.new_price * cartItem[e.id]}</p>
                  <img
                    src={remove_icon}
                    alt=""
                    onClick={() => {
                      removeFromCart(e.id);
                    }}
                    className="remove"
                  />
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
      <div className="down">
        <div className="total">
          <h1>CART TOTAL</h1>
          <div>
            <div className="total-item">
              <p>Subtotal</p>
              <p>${getTotalCartAmount()}</p>
            </div>
            <hr />
            <div className="total-item">
              <p>Shipping Fee</p>
              <p>Free</p>
            </div>
            <hr />
            <div className="total-item">
              <h3>Total</h3>
              <h3>${getTotalCartAmount()}</h3>
            </div>
          </div>
          <button>PROCEED TO CHECKOUT</button>
        </div>
        <div className="promocode">
          <p>If you have a promo code, Enter it here</p>
          <div className="promobox">
            <input type="text" placeholder="promo code" />
            <button>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
